<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleNextStep = async () => {
  await handleNext('tutorial_map_settings')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        <i18n-t keypath="tutorial.mapSettings.visualizeScanRange" tag="span">
          <template #cogIcon><GenericIcon type="cog"/></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        <i18n-t keypath="tutorial.mapSettings.clickCog" tag="span">
          <template #cogIcon><GenericIcon type="cog"/></template>
        </i18n-t>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">{{ t('common.actions.gotIt') }}</ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>